import * as ambassadorWixReceiptsPresetsV1ReceiptPreset from './receipts-presets-v1-receipt-preset-receipt-presets.http.js';
import * as ambassadorWixReceiptsPresetsV1ReceiptPresetTypes from './receipts-presets-v1-receipt-preset-receipt-presets.types.js';
import * as ambassadorWixReceiptsPresetsV1ReceiptPresetUniversalTypes from './receipts-presets-v1-receipt-preset-receipt-presets.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createReceiptPreset(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixReceiptsPresetsV1ReceiptPresetUniversalTypes.CreateReceiptPresetRequest,
  ambassadorWixReceiptsPresetsV1ReceiptPresetTypes.CreateReceiptPresetRequest,
  ambassadorWixReceiptsPresetsV1ReceiptPresetUniversalTypes.CreateReceiptPresetResponse,
  ambassadorWixReceiptsPresetsV1ReceiptPresetTypes.CreateReceiptPresetResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixReceiptsPresetsV1ReceiptPreset.createReceiptPreset(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/receipt-presets',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getReceiptPreset(): __PublicMethodMetaInfo<
  'GET',
  { receiptPresetId: string },
  ambassadorWixReceiptsPresetsV1ReceiptPresetUniversalTypes.GetReceiptPresetRequest,
  ambassadorWixReceiptsPresetsV1ReceiptPresetTypes.GetReceiptPresetRequest,
  ambassadorWixReceiptsPresetsV1ReceiptPresetUniversalTypes.GetReceiptPresetResponse,
  ambassadorWixReceiptsPresetsV1ReceiptPresetTypes.GetReceiptPresetResponse
> {
  const payload = { receiptPresetId: ':receiptPresetId' } as any;

  const getRequestOptions =
    ambassadorWixReceiptsPresetsV1ReceiptPreset.getReceiptPreset(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/receipt-presets/{receiptPresetId}',
    pathParams: { receiptPresetId: 'receiptPresetId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getDefaultReceiptPreset(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixReceiptsPresetsV1ReceiptPresetUniversalTypes.GetDefaultReceiptPresetRequest,
  ambassadorWixReceiptsPresetsV1ReceiptPresetTypes.GetDefaultReceiptPresetRequest,
  ambassadorWixReceiptsPresetsV1ReceiptPresetUniversalTypes.GetDefaultReceiptPresetResponse,
  ambassadorWixReceiptsPresetsV1ReceiptPresetTypes.GetDefaultReceiptPresetResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixReceiptsPresetsV1ReceiptPreset.getDefaultReceiptPreset(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/receipt-presets/default',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateReceiptPreset(): __PublicMethodMetaInfo<
  'PATCH',
  { receiptPresetId: string },
  ambassadorWixReceiptsPresetsV1ReceiptPresetUniversalTypes.UpdateReceiptPresetRequest,
  ambassadorWixReceiptsPresetsV1ReceiptPresetTypes.UpdateReceiptPresetRequest,
  ambassadorWixReceiptsPresetsV1ReceiptPresetUniversalTypes.UpdateReceiptPresetResponse,
  ambassadorWixReceiptsPresetsV1ReceiptPresetTypes.UpdateReceiptPresetResponse
> {
  const payload = { receiptPreset: { id: ':receiptPresetId' } } as any;

  const getRequestOptions =
    ambassadorWixReceiptsPresetsV1ReceiptPreset.updateReceiptPreset(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/receipt-presets/{receiptPreset.id}',
    pathParams: { receiptPresetId: 'receiptPresetId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function setDefaultReceiptPreset(): __PublicMethodMetaInfo<
  'POST',
  { receiptPresetId: string },
  ambassadorWixReceiptsPresetsV1ReceiptPresetUniversalTypes.SetDefaultReceiptPresetRequest,
  ambassadorWixReceiptsPresetsV1ReceiptPresetTypes.SetDefaultReceiptPresetRequest,
  ambassadorWixReceiptsPresetsV1ReceiptPresetUniversalTypes.SetDefaultReceiptPresetResponse,
  ambassadorWixReceiptsPresetsV1ReceiptPresetTypes.SetDefaultReceiptPresetResponse
> {
  const payload = { receiptPresetId: ':receiptPresetId' } as any;

  const getRequestOptions =
    ambassadorWixReceiptsPresetsV1ReceiptPreset.setDefaultReceiptPreset(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/receipt-presets/default/{receiptPresetId}',
    pathParams: { receiptPresetId: 'receiptPresetId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteReceiptPreset(): __PublicMethodMetaInfo<
  'DELETE',
  { receiptPresetId: string },
  ambassadorWixReceiptsPresetsV1ReceiptPresetUniversalTypes.DeleteReceiptPresetRequest,
  ambassadorWixReceiptsPresetsV1ReceiptPresetTypes.DeleteReceiptPresetRequest,
  ambassadorWixReceiptsPresetsV1ReceiptPresetUniversalTypes.DeleteReceiptPresetResponse,
  ambassadorWixReceiptsPresetsV1ReceiptPresetTypes.DeleteReceiptPresetResponse
> {
  const payload = { receiptPresetId: ':receiptPresetId' } as any;

  const getRequestOptions =
    ambassadorWixReceiptsPresetsV1ReceiptPreset.deleteReceiptPreset(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/receipt-presets/{receiptPresetId}',
    pathParams: { receiptPresetId: 'receiptPresetId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listReceiptPresets(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixReceiptsPresetsV1ReceiptPresetUniversalTypes.ListReceiptPresetsRequest,
  ambassadorWixReceiptsPresetsV1ReceiptPresetTypes.ListReceiptPresetsRequest,
  ambassadorWixReceiptsPresetsV1ReceiptPresetUniversalTypes.ListReceiptPresetsResponse,
  ambassadorWixReceiptsPresetsV1ReceiptPresetTypes.ListReceiptPresetsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixReceiptsPresetsV1ReceiptPreset.listReceiptPresets(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/receipt-presets',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateExtendedFields(): __PublicMethodMetaInfo<
  'POST',
  { id: string },
  ambassadorWixReceiptsPresetsV1ReceiptPresetUniversalTypes.UpdateExtendedFieldsRequest,
  ambassadorWixReceiptsPresetsV1ReceiptPresetTypes.UpdateExtendedFieldsRequest,
  ambassadorWixReceiptsPresetsV1ReceiptPresetUniversalTypes.UpdateExtendedFieldsResponse,
  ambassadorWixReceiptsPresetsV1ReceiptPresetTypes.UpdateExtendedFieldsResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions =
    ambassadorWixReceiptsPresetsV1ReceiptPreset.updateExtendedFields(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/receipt-presets/{id}/update-extended-fields',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  ReceiptPreset as ReceiptPresetOriginal,
  DisplaySettings as DisplaySettingsOriginal,
  BusinessDisplayOptions as BusinessDisplayOptionsOriginal,
  CustomerDisplayOptions as CustomerDisplayOptionsOriginal,
  ItemsDisplayOption as ItemsDisplayOptionOriginal,
  TotalsDisplayOption as TotalsDisplayOptionOriginal,
  CustomFields as CustomFieldsOriginal,
  CustomField as CustomFieldOriginal,
  FooterCustomField as FooterCustomFieldOriginal,
  DisplayValues as DisplayValuesOriginal,
  ExtendedFields as ExtendedFieldsOriginal,
  CreateReceiptPresetRequest as CreateReceiptPresetRequestOriginal,
  CreateReceiptPresetResponse as CreateReceiptPresetResponseOriginal,
  GetReceiptPresetRequest as GetReceiptPresetRequestOriginal,
  GetReceiptPresetResponse as GetReceiptPresetResponseOriginal,
  GetDefaultReceiptPresetRequest as GetDefaultReceiptPresetRequestOriginal,
  GetDefaultReceiptPresetResponse as GetDefaultReceiptPresetResponseOriginal,
  UpdateReceiptPresetRequest as UpdateReceiptPresetRequestOriginal,
  UpdateReceiptPresetResponse as UpdateReceiptPresetResponseOriginal,
  SetDefaultReceiptPresetRequest as SetDefaultReceiptPresetRequestOriginal,
  SetDefaultReceiptPresetResponse as SetDefaultReceiptPresetResponseOriginal,
  DeleteReceiptPresetRequest as DeleteReceiptPresetRequestOriginal,
  DeleteReceiptPresetResponse as DeleteReceiptPresetResponseOriginal,
  ListReceiptPresetsRequest as ListReceiptPresetsRequestOriginal,
  ListReceiptPresetsResponse as ListReceiptPresetsResponseOriginal,
  UpdateExtendedFieldsRequest as UpdateExtendedFieldsRequestOriginal,
  UpdateExtendedFieldsResponse as UpdateExtendedFieldsResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  CreateReceiptPresetApplicationErrors as CreateReceiptPresetApplicationErrorsOriginal,
  GetDefaultReceiptPresetApplicationErrors as GetDefaultReceiptPresetApplicationErrorsOriginal,
  UpdateReceiptPresetApplicationErrors as UpdateReceiptPresetApplicationErrorsOriginal,
  DeleteReceiptPresetApplicationErrors as DeleteReceiptPresetApplicationErrorsOriginal,
  ListReceiptPresetsApplicationErrors as ListReceiptPresetsApplicationErrorsOriginal,
} from './receipts-presets-v1-receipt-preset-receipt-presets.types.js';
